import {
  TABLE_WRAPPER_DESIGN_VERSION_TOKEN,
  UI_UX_INPUT_NUMBER_PROVIDER,
} from '@shared/ui-ux-components/ui-ux-components.config';

export const ARKIK_WEB_COMPONENTS_PROVIDERS = [
  { provide: TABLE_WRAPPER_DESIGN_VERSION_TOKEN, useValue: 'v1' },
  { provide: UI_UX_INPUT_NUMBER_PROVIDER, useValue: { hideUnitOnFocus: true } },
];
